import {
  GET_ACTIVITY_DATA_SUCCESS,
  GET_ACTIVITY_DATA_ERROR,
  ASSETS_LOADED_SUCCESS,
  ASSETS_LOADED_ERROR,
  START_ACTIVITY,
  NEXT_ACTIVITY,
  RESET_ACTIVITY_STORE,
  ACTIVITY_FLOW_COMPLETE,
  SET_LEVEL_OVERRIDE,
  TOGGLE_VIDEO,
  TOGGLE_MODAL,
  COUNTERS_FLIP_CARD,
  SKIP_RECORDING_ACTIVITY,
  REPEAT_ACTIVITY,
  RESET_RESTARTING_FLAG
} from '../types/activity';

export const initialState = {
  data: {
    activities: [],
    level: 0
  },
  dataLoaded: false,
  assetsLoaded: false,
  activities: [],
  currentRoundIndex: -1,
  started: false,
  flowComplete: false,
  levelOverride: 0,
  isVideoModalOpen: false,
  isModalOpen: false,
  isRecordingActivitySkipped: false,
  rounds: [],
  repeatActivity: false,
  isCountersFlipCard: false,
  isRestarting: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ACTIVITY_DATA_SUCCESS:
      return { ...state, data: action.payload };
    case GET_ACTIVITY_DATA_ERROR:
      return { ...state, error: action.payload };
    case ASSETS_LOADED_SUCCESS:
      return { ...state, assetsLoaded: true, activities: action.payload };
    case ASSETS_LOADED_ERROR:
      return { ...state, error: action.payload };
    case START_ACTIVITY:
      return {
        ...state,
        started: true,
        currentRoundIndex: state.repeatActivity ? state.currentRoundIndex : 0
      };
    case REPEAT_ACTIVITY:
      return {
        ...state,
        currentRoundIndex: state.currentRoundIndex,
        repeatActivity: true,
        isRestarting: true
      };
    case NEXT_ACTIVITY:
      return { ...state, currentRoundIndex: state.currentRoundIndex + 1, repeatActivity: false };
    case ACTIVITY_FLOW_COMPLETE:
      return { ...state, started: false, flowComplete: true };
    case SET_LEVEL_OVERRIDE:
      return { ...state, levelOverride: action.payload };
    case TOGGLE_VIDEO:
      return { ...state, isVideoModalOpen: action.isVideoModalOpen };
    case TOGGLE_MODAL:
      return { ...state, isModalOpen: action.isModalOpen };
    case SKIP_RECORDING_ACTIVITY:
      return { ...state, isRecordingActivitySkipped: action.isRecordingActivitySkipped };
    case COUNTERS_FLIP_CARD:
      return { ...state, isCountersFlipCard: action.isCountersFlipCard };
    case RESET_ACTIVITY_STORE:
      return { ...initialState };
    case RESET_RESTARTING_FLAG:
      return { ...state, isRestarting: false };
    default:
      return state;
  }
};
